import { colors, Spinner } from "@hubrise/react-components"
import * as React from "react"

import Layout from "shared/components/Layout"

import { Page } from "./Styles"

const PageSpinner = (): JSX.Element => (
  <Layout>
    <Page>
      <Spinner size={120} secondaryColor={colors.backgroundMedium} />
    </Page>
  </Layout>
)

export default PageSpinner
